const fetchNavItem = require("./fetchNavItem");

/**
 * Look for a hierarchy tree of a given entity
 *
 * @param {*} _entity: an entity to look ancestors to
 * @param {*} sitemap: a list of navigation items
 * @returns
 */

module.exports = async function fetchAncestors(_entity) {
	const nid = _entity.attributes
		? parseInt(_entity.attributes.drupal_internal__nid)
		: null;
	if (!nid) return [];
	let sitemap = await fetchNavItem(_entity, true);
	if (!sitemap) return [];
	let ancestors = [];
	function get_ancestor(item) {
		let _ancestor = item.parent_nid
			? sitemap.find((i) => parseInt(i.nid) === parseInt(item.parent_nid))
			: null;
		if (_ancestor) {
			ancestors.push(_ancestor);
			get_ancestor(_ancestor);
		}
	}
	let item = sitemap.find((i) => parseInt(i.nid) === parseInt(nid));
	if (item) {
		get_ancestor(item);
	}
	if (ancestors.length > 0) {
		ancestors.reverse();
		ancestors.push(item);
	}
	return ancestors;
};
